import {Outlet, useMatch} from "react-router";
import ManagementWorkspace from "@/components/management/ManagementWorkspace.tsx";
import SpellListPanel from "@/spells/SpellListPanel.tsx";

export default function SpellWorkspace() {
    const createMatch = useMatch("/campaigns/:campaignSlug/spells/new");
    const detailMatch = useMatch("/campaigns/:campaignSlug/spells/:id");
    const editMatch = useMatch("/campaigns/:campaignSlug/spells/:id/edit");
    const selectedId = createMatch ? undefined : editMatch?.params.id ?? detailMatch?.params.id;

    return (
        <ManagementWorkspace sidebar={<SpellListPanel selectedId={selectedId}/> }>
            <Outlet/>
        </ManagementWorkspace>
    );
}
